/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowElbowRightUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M231.39062,99.06152A8,8,0,0,1,224,104H184v88a8.00008,8.00008,0,0,1-8,8H32a8,8,0,0,1,0-16H168V104H128a8.00037,8.00037,0,0,1-5.65723-13.65674l48-48a8.00122,8.00122,0,0,1,11.31446,0l48,48A7.99949,7.99949,0,0,1,231.39062,99.06152Z" />
    </Svg>
  );
}

export default ArrowElbowRightUp;
